// TODO: CONVERT TO TYPESCRIPT
import React, { useRef } from 'react'
import PropTypes from 'prop-types'

const SearchForm = (props) => {
  const searchTermRef = useRef(null)

  const handleSubmit = (event) => {
    event.preventDefault()
    props.executeNewSearch({ searchTerm: searchTermRef.current.value })
  }

  return (
    <form onSubmit={handleSubmit} id='supplier-search-main-form'>
      <div id='supplier-search' className='grid-x'>
        <div className='medium-auto small-12 cell search-box'>
          <i className='fa fa-search' />
          <input
            type='text'
            name='search'
            defaultValue={props.searchTerm}
            ref={searchTermRef}
            id='supplier-search-box'
          />
        </div>

        <div className='medium-shrink small-4 cell'>
          <button
            type='submit'
            className='supplier-search-btn button'
            id='supplier-search-button'
          >
            SEARCH
          </button>
        </div>
      </div>
    </form>
  )
}

SearchForm.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  executeNewSearch: PropTypes.func.isRequired
}

export default SearchForm
